import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AccountLayout, StatusBadge } from "../shared";

/** /mail-check/:email — le lien de réinitialisation est parti. */
const MailCheck = ({ match }) => {
  const { t } = useTranslation();
  let email = match?.params?.email || "";
  try {
    email = decodeURIComponent(email);
  } catch (error) {
    /* adresse déjà décodée */
  }

  return (
    <AccountLayout t={t}>
      <StatusBadge icon="i-mail" />
      <h1 className="wosh-auth__title">{t("Check your email")}</h1>
      <p className="wosh-auth__lede">
        {t("We've sent a link to")} <span className="wosh-acc__email">{email}</span>.{" "}
        {t("It can take a few minutes. Check your spam folder too.")}
      </p>

      <Link to="/sign-in" className="wosh-auth__cta wosh-acc__cta">
        {t("Back to sign in")}
      </Link>

      <p className="wosh-auth__switch">
        {t("Didn't receive the link?")} <Link to="/forgot-password">{t("Try another email address")}</Link>
      </p>
    </AccountLayout>
  );
};

export default MailCheck;
